import EventEmitter from "eventemitter3";

export const enum EmitterEvents {
  IN_A_COMMUNITY = "inACommunity",
  EASTER_EGG_MODAL = "easterEggModal",
  REWARD_INTERACTION_ONBOARDING = "rewardInteractionOnboarding",
  OPEN_CREATION_STUDIO_MODAL = "openCreationStudioModal",
  BOTTOM_SHEET_DISPLAY = "bottom_sheet_display",
}
const emitter = new EventEmitter();

export default emitter;
